module.exports = __webpack_public_path__ + "static/media/image-10.a3b47899.jpg";